import i18next from "i18next";
import { Column } from "../objects/column";
import { CommercialAgentTableHead } from "../objects/commercialAgentTableHead";
import { CommercialErrors } from "../objects/commercialErrors";
import { CommercialListConfiguration } from "../objects/commercialListConfiguration";
import { CommercialListCriteria } from "../objects/commercialListCriteria";
import { CommercialListFiltersCriteria } from "../objects/commercialListFiltersCriteria";
import * as locales from 'date-fns/locale';
import { format } from "date-fns";


const locales_cpy: { [key: string]: any } = locales;
const domain = window.location.host.split('.')[1];
export const COMMERCIAL_MODULE = 'COMMERCIAL';
export const COMMERCIAL_TRIP_MODULE = 'COMMERCIAL_TRIP_MODULE';
export const COMMERCIAL_INFO_ROUTE = '/commercial/edit/:id/info';

export const EMPTY_COMMERCIAL_FILTERS: CommercialListFiltersCriteria = {
    name: '',
    creator: "",
    last_author: "",
    created_date_gte: null,
    created_date_lte: null,
    modified_date_gte: null,
    modified_date_lte: null,
    period_type: 0,
    period: "MODIFICATION",
    first_name: "",
    email: ""
};

export const EMPTY_COMMERCIAL_ERRORS: CommercialErrors = {
    last_name_error: "",
    first_name_error: ""
};

export const EMPTY_COMMERCIAL_LIST_CRITERIA: CommercialListCriteria = {
    limit: 50,
    page: 0,
    order_by: '',
    order: 'asc',
    filters: EMPTY_COMMERCIAL_FILTERS,
    search: ''
};

export const DEFAULT_COLUMN: Column[] = [{
    label: 'name',
    field_name: 'NAME',
    checked: true,
    order_by: 'first_name',
    fixed_width: false,
    last_updated: false
}, {
    label: 'username',
    field_name: 'USERNAME',
    checked: false,
    order_by: 'username',
    fixed_width: false,
    last_updated: false
}, {
    label: 'email',
    field_name: 'EMAIL',
    checked: true,
    order_by: 'email',
    fixed_width: false,
    last_updated: false
}, {
    label: 'organisation',
    field_name: 'ORGANISATION',
    checked: true,
    order_by: 'client__name',
    fixed_width: false,
    last_updated: false
}, {
    label: 'date-joined',
    field_name: 'DATE_JOINED',
    checked: false,
    order_by: 'date_joined',
    fixed_width: true,
    last_updated: false
}, {
    label: 'created-by',
    field_name: 'CREATED_BY',
    checked: false,
    order_by: 'creator__username',
    fixed_width: false,
    last_updated: false
}, {
    label: 'modified-date',
    field_name: 'MODIFIED_DATE',
    checked: true,
    order_by: 'modified_date',
    fixed_width: true,
    last_updated: false
}, {
    label: 'modified-by',
    field_name: 'MODIFIED_BY',
    checked: true,
    order_by: 'last_author__username',
    fixed_width: false,
    last_updated: false
}, {
    label: 'email-checked',
    field_name: 'EMAIL_CHECKED',
    checked: true,
    order_by: 'email_checked',
    fixed_width: false,
    last_updated: false
}];

export const MCI_COLUMN: Column[] = [...DEFAULT_COLUMN, {
    label: 'company',
    field_name: 'COMPANY',
    checked: true,
    order_by: 'company',
    fixed_width: false,
    last_updated: false
}];

export const EMPTY_COMMERCIAL_LIST_CONFIGURATION: CommercialListConfiguration = {
    columns: domain === 'tripmci' ? MCI_COLUMN : DEFAULT_COLUMN,
    preferences: []
};


export const COMMERCIAL_AGENT_TABLE_HEAD: CommercialAgentTableHead[] = [
    {
        field_name: "name",
        label: "name",
        sortable: true,
        getValue: (organisation) => `${organisation.name ?? ''}${organisation.street ? ' ,' + organisation.street : ''}${organisation.zip_code? ' ,' + organisation.zip_code : ''}${organisation.city ? ' ,' + organisation.city : ''}${organisation.state ? ' ,' + organisation.state.international_name : ''}`,
    },
    {
        field_name: "created_date",
        label: "created-date",
        sortable: true,
        getValue: (organisation) => organisation.created_date ? format(new Date(organisation.created_date), 'P HH:mm', { locale: locales_cpy[i18next.language] }) : '-',
    },
    {
        field_name: "creator",
        label: "created-by",
        sortable: true,
        getValue: (organisation) => organisation.creator ? organisation.creator.username : '-',
    },
    {
        field_name: "modified_date",
        label: "modified-date",
        sortable: true,
        getValue: (organisation) => organisation.modified_date ? format(new Date(organisation.modified_date), 'P HH:mm', { locale: locales_cpy[i18next.language] }) : '-',
    },
    {
        field_name: "last_author",
        label: "modified-by",
        sortable: true,
        getValue: (organisation) => organisation.last_author ? organisation.last_author.username : '-'
    }
];

export const HTTP_HEADER = {
    'Authorization': `Token ${localStorage.getItem('token')}`,
    'Accept': 'application/json',
    'Content-Type': 'application/json',
    'Accept-Language': 'fr'
};